import { css, type SerializedStyles } from '@emotion/react'
import { useMemo } from 'react'
import { colors } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/products/utils/domain/intl'

type DepartmentOrAisle = { name: string; id: string; aisles?: DepartmentOrAisle[] }

interface TreeNode {
  label: string
  key: string
  nodes?: TreeNode[]
  css?: SerializedStyles
}

const showAllStyles = css({
  color: colors.PRIMARY.REGULAR,
})

const toNode = ({ name, id, aisles }: DepartmentOrAisle): TreeNode => ({
  label: name,
  key: id,
  nodes: aisles?.map(toNode),
})

export const useGetDepartmentsAndAislesTreeNodes = (input: DepartmentOrAisle[]): TreeNode[] => {
  const showAllLabel = useDomainMessage('productsDomain.search.filters.departmentsAndAisles.all')

  return useMemo(() => {
    if (!input) return []

    const treeNodes = input.map(toNode)

    treeNodes.unshift({
      label: showAllLabel,
      key: undefined,
      css: showAllStyles,
    })

    return treeNodes
  }, [input, showAllLabel])
}
